export const NEW_PASSWORD       = 'new-password';
export const VISIBILITY_ICON    = 'visibility-icon';
export const NO_VISIBILITY_ICON = 'no-visibility-icon';
